var _defs, _rect, _rect2, _rect3, _polygon, _polygon2, _rect4, _rect5, _rect6, _polygon3, _polygon4, _path, _path2, _rect7, _rect8, _path3, _path4, _rect9, _rect10, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect11, _rect12, _rect13, _polygon5, _polygon6, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdeaapplicationsMonochromatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 314.19 397",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 168.55,
    y1: 256.86,
    x2: 300.46,
    y2: 488.27,
    gradientTransform: "translate(376.51 582.84) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 159.41,
    y1: 262.07,
    x2: 291.32,
    y2: 493.48,
    gradientTransform: "translate(399.12 665) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 150.27,
    y1: 267.28,
    x2: 282.18,
    y2: 498.69,
    gradientTransform: "translate(421.73 747.16) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 110.15,
    y1: 246.31,
    x2: 242.06,
    y2: 477.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 67.48,
    y1: 270.63,
    x2: 199.39,
    y2: 502.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 274.09,
    cy: 117.66,
    r: 41.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.39
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 5825.07,
    y1: 1536.61,
    x2: 5866.18,
    y2: 1536.61,
    gradientTransform: "translate(-5570.1 -1473.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 5822.88,
    y1: 1536.87,
    x2: 5868.85,
    y2: 1536.87,
    gradientTransform: "translate(-5570.57 -1474.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 187.59,
    y1: 191.86,
    x2: 173.08,
    y2: 233.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 229.17,
    y1: 141.42,
    x2: 198.64,
    y2: 145.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 229.17,
    y1: 197.15,
    x2: 168.49,
    y2: 197.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 137.17,
    y1: 238.4,
    x2: 175.05,
    y2: 231.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 194.68,
    y1: 283.35,
    x2: 217.48,
    y2: 259.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "idea applications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M362.37,233.06c.3,23.78,7.6,47.39,5,71-4.88,44-45.08,78.52-88.57,86.77-22.51,4.27-47.39,2.19-65.76-11.5-6.78-5.06-12.42-11.51-19.11-16.7-21.41-16.63-51.14-18.87-73.28-34.51-25.8-18.23-36.54-50.94-43.21-81.82q-5.88-27.2-9.22-54.86c-3.34-27.56-4-58.1,13.09-80,12.77-16.43,33-24.73,50.65-35.78,23.3-14.58,42.76-34.58,65.48-50.07C223.1,8.09,247.16,3.34,272.74,7.4l2.26.38A168.24,168.24,0,0,1,308.76,18c34.1,13.89,63.7,43,70.23,80.27C386.84,143.11,361.81,187.53,362.37,233.06Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.45,
    y: 287.28,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    transform: "translate(310.19 576.8) rotate(180)",
    fill: "#EBCA94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163.76,
    y: 328.36,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    transform: "translate(332.8 658.96) rotate(-180)",
    fill: "#EBCA94"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175.06,
    y: 369.44,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    transform: "translate(355.41 741.12) rotate(180)",
    fill: "#EBCA94"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "172.75 397 182.93 397 155.22 284.5 145.05 284.5 172.75 397",
    fill: "#EBCA94"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.22 397 126.39 397 98.69 284.5 88.52 284.5 116.22 397",
    fill: "#EBCA94"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.45,
    y: 287.28,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    transform: "translate(310.19 576.8) rotate(180)",
    fill: "url(#linear-gradient)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 163.76,
    y: 328.36,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    transform: "translate(332.8 658.96) rotate(-180)",
    fill: "url(#linear-gradient-2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 175.06,
    y: 369.44,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    transform: "translate(355.41 741.12) rotate(180)",
    fill: "url(#linear-gradient-3)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "172.75 397 182.93 397 155.22 284.5 145.05 284.5 172.75 397",
    fill: "url(#linear-gradient-4)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "116.22 397 126.39 397 98.69 284.5 88.52 284.5 116.22 397",
    fill: "url(#linear-gradient-5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.45,109.88a6.4,6.4,0,0,1,4.64-2,9.51,9.51,0,0,1-1.57,4.69,7,7,0,0,0-.88,1.78,1.9,1.9,0,0,0,.4,1.85c.33.32.81.47,1,.86a1.19,1.19,0,0,1-.34,1.42,3.48,3.48,0,0,1-1.43.66l-2.6.73a3.1,3.1,0,0,1-2,.11C231.72,118.3,237,111.39,238.45,109.88Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#f3bd8f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.15,122.05a10.08,10.08,0,0,0,4.26-1.81,25.86,25.86,0,0,0,5.51-4.93,19.5,19.5,0,0,1,5.61,7.09,1.5,1.5,0,0,1-.23,2c-3.75,4.33-8.64,8.31-14.37,8.52a12.59,12.59,0,0,1-8.52-2.93c-2.36-2-6.62-8.85-3.26-11.64,1.78-1.48,3.22.4,4.55,1.45A8.88,8.88,0,0,0,223.15,122.05Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 254.97,
    y: 53.25,
    width: 41.11,
    height: 19.62,
    rx: 4.09,
    transform: "translate(484.73 120.09) rotate(180)",
    fill: "#EBCA94"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 252.3,
    y: 59.24,
    width: 45.97,
    height: 7.13,
    rx: 3.44,
    transform: "translate(484.25 119.57) rotate(-180)",
    fill: "#EBCA94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.77,126.55a36.06,36.06,0,0,1,4.11-16.79l14.95-37.3H293.4l13.9,39.35a36.33,36.33,0,1,1-69.53,14.74Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.77,126.55a36.06,36.06,0,0,1,4.11-16.79l14.95-37.3H293.4l13.9,39.35a36.33,36.33,0,1,1-69.53,14.74Z",
    transform: "translate(-66.32 -6.04)",
    opacity: 0.69,
    fill: "url(#radial-gradient)",
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280,71.86a83.45,83.45,0,0,1,8.22,35.7c0,2.77-.4,6-2.82,7.38-3,1.65-6.64-.93-8.26-3.91a15.63,15.63,0,0,1-.88-12.83c2,2.47,2.53,5.72,2.86,8.84a15.34,15.34,0,0,1-.41,6.88c-.79,2.18-2.74,4.1-5.06,4.18-3.56.12-5.87-3.87-6.27-7.42A18.16,18.16,0,0,1,270,99.11a13.61,13.61,0,0,1-2.8,13.37,7.83,7.83,0,0,1-4.06,2.53,4.3,4.3,0,0,1-4.34-1.52,5.89,5.89,0,0,1-.86-2.61c-1-6.69,1.38-13.42,4.28-19.53s6.42-12,8.13-18.55",
    transform: "translate(-66.32 -6.04)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.39
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 254.97,
    y: 53.25,
    width: 41.11,
    height: 19.62,
    rx: 4.09,
    transform: "translate(484.73 120.09) rotate(180)",
    fill: "url(#linear-gradient-6)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 252.3,
    y: 59.24,
    width: 45.97,
    height: 7.13,
    rx: 3.44,
    transform: "translate(484.25 119.57) rotate(-180)",
    fill: "url(#linear-gradient-7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.78,212.73a31.61,31.61,0,0,1-.38,4.66,48.65,48.65,0,0,1-2.4,7.36,87.77,87.77,0,0,0-3,11.77l-5.83,28.67a2.24,2.24,0,0,0,0,1.23,2,2,0,0,0,.7.81A11.37,11.37,0,0,0,199,269a1.78,1.78,0,0,0,1.13.13,2,2,0,0,0,1-1.09,54.39,54.39,0,0,0,5.14-12.4c6-20.85,12.43-33.44,13.62-43.73.2-1.67,2-3.18,1.12-4.61a6.52,6.52,0,0,0-2.19-2.27c-2.27-1.52-7.42-6-10.44-4.22C205.71,202.28,206.87,210.05,206.78,212.73Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#f3bd8f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.76,212.22a2.5,2.5,0,0,1-2.56,2.21c-13.84,2.1-28.31,2.41-40.94,8.43a4.75,4.75,0,0,0-2.1,1.55c-1.17,1.82.35,4.31-.32,6.36,7.81.24,15.59-1,23.3-2.26l28.64-4.64c1.82-.3,3.77-.66,5.06-2a8.8,8.8,0,0,0,1.86-4l2.24-8.42c.45-1.66.87-3.48.13-5-1-2.15-3.78-2.73-6.15-2.86C195.88,201.2,195.43,206.72,193.76,212.22Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#f3bd8f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.76,212.22a2.5,2.5,0,0,1-2.56,2.21c-13.84,2.1-28.31,2.41-40.94,8.43a4.75,4.75,0,0,0-2.1,1.55c-1.17,1.82.35,4.31-.32,6.36,7.81.24,15.59-1,23.3-2.26l28.64-4.64c1.82-.3,3.77-.66,5.06-2a8.8,8.8,0,0,0,1.86-4l2.24-8.42c.45-1.66.87-3.48.13-5-1-2.15-3.78-2.73-6.15-2.86C195.88,201.2,195.43,206.72,193.76,212.22Z",
    transform: "translate(-66.32 -6.04)",
    fill: "url(#linear-gradient-8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.2,131.05c.21-.43.69-.92,1.05-.63a.81.81,0,0,1,.23.54l.32,2.16a.79.79,0,0,0,.13.4c.25.29.72.1,1-.12a26.52,26.52,0,0,0,4.88-4.34c.28-.32.68-.68,1.08-.51a.91.91,0,0,1,.42.52,7.29,7.29,0,0,1,.31,3.85,10.86,10.86,0,0,1-1.53,4.5,6.42,6.42,0,0,1-3.73,2.82c-1.23.31-2.58.18-3.71.76-.68.35-1.31.95-2.07.87-.94-.1-1.43-1.18-1.52-2.12C247.8,136.65,249.89,133.71,251.2,131.05Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#f3bd8f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213.27,97.33c.29,2.84.6,5.87,2.42,8.07.75.91,1.72,1.63,2.39,2.6a5.39,5.39,0,0,1,.95,3.09c-4.85-.22-9.6,2-14.44,1.56a23,23,0,0,1,.35-8.05c.83-3.69,2.6-7.25,2.43-11-.05-1.24-.35-2.77.43-3.87.65-.91,2.16-1.39,3-.49a10.61,10.61,0,0,1,1.6,3.42A21.49,21.49,0,0,1,213.27,97.33Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#3e3e54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M210,113.15c8.56,5,12,23.41,13.37,27.94a66.69,66.69,0,0,1,2.51,21.15c-.07,3.14-.3,6.39-1.68,9.21-1.9,3.88-5.78,6.51-9.91,7.75s-8.53,1.25-12.83,1c-2.78-.15-5.76-.47-7.87-2.28-2.88-2.47-3.17-6.74-3.21-10.54q-.27-22.54.45-45.11a22.86,22.86,0,0,1,.9-6.7,7.82,7.82,0,0,1,4.33-4.94C199.88,109.21,206.44,111.05,210,113.15Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210,113.15c8.56,5,12,23.41,13.37,27.94a66.69,66.69,0,0,1,2.51,21.15c-.07,3.14-.3,6.39-1.68,9.21-1.9,3.88-5.78,6.51-9.91,7.75s-8.53,1.25-12.83,1c-2.78-.15-5.76-.47-7.87-2.28-2.88-2.47-3.17-6.74-3.21-10.54q-.27-22.54.45-45.11a22.86,22.86,0,0,1,.9-6.7,7.82,7.82,0,0,1,4.33-4.94C199.88,109.21,206.44,111.05,210,113.15Z",
    transform: "translate(-66.32 -6.04)",
    fill: "url(#linear-gradient-9)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.26,103.1a4.13,4.13,0,0,1-.92,2.85,3.62,3.62,0,0,1-2.83.76,20.27,20.27,0,0,0-3-.27,1.64,1.64,0,0,0-1.84,1.78c0,1.39.59,2.72.58,4.11s-1.07,3-2.43,2.7a2.7,2.7,0,0,1-1.55-1.24c-1.93-2.81-2.05-6.49-3.52-9.58-.86-1.81-2.18-3.4-2.81-5.31a8.74,8.74,0,0,1,2.66-9.06c2.53-2.19,8.37-3.83,11.1-1.09C212.13,92.2,213.44,98.43,213.26,103.1Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#f3bd8f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M207.72,83.58a7.38,7.38,0,0,1,1.87,1,9.35,9.35,0,0,1,2.76,4.65l-7.12,3.81a1.2,1.2,0,0,1-.72.2c-.51-.09-.75-.8-1.26-.83a5.73,5.73,0,0,1,.57,1.32l-2.78,2a3,3,0,0,0-.81.72,3.09,3.09,0,0,0-.36,1.83,82.15,82.15,0,0,0,2.43,15.8,8,8,0,0,1-3.45,1,49,49,0,0,0-13.23,4,16.5,16.5,0,0,0-.65-4.24,11.83,11.83,0,0,1-.78-3.45,10,10,0,0,1,1.21-3.82c.78-1.72,1.44-3.49,2.1-5.26a15,15,0,0,0,1-3.69,24.38,24.38,0,0,0-.42-4.88,6.66,6.66,0,0,1,.9-4.71c1.43-1.92,4.16-2.45,6.11-3.68A14.53,14.53,0,0,1,203,82.74,12.68,12.68,0,0,1,207.72,83.58Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#3e3e54"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.91,152.58c2,2,11.11,4.06,14.35,4,8.38,0,25.84-10.38,25.54-11.13l-5.13-12.59c-4.33,2.84-8.86,5.58-13.93,6.61s-10.82.06-14.41-3.66c-2.56-2.66-3.73-6.34-5.8-9.39s-5.9-5.62-9.31-4.22c-4.49,1.84-5.52,9.23-3.91,13.16C202.89,141.73,208.15,147.79,212.91,152.58Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.39,203.13c-.33,1-.7,2-1.08,3-1.08,2.73-2.14,6.38.19,8.17a5.44,5.44,0,0,0,2.76.92c3.28.37,6.6-.26,9.9-.19,7.21.14,13.92,3.55,20.16,7.16a14,14,0,0,0,4.29,1.88,4.49,4.49,0,0,0,4.29-1.29c1-1.25,1-3,.9-4.64l-1.55-30c-.19-3.67,1-15.1-3.37-16.13-2.78-.66-7.08.7-10,.89-3.51.24-7,.34-10.56.33a18.59,18.59,0,0,1-5.2-.59c-1-.32-4.28-2.13-5.39-1.88-3.39.8-1.94,11.94-2.05,14.56A64,64,0,0,1,185.39,203.13Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#3e3e54"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M185.39,203.13c-.33,1-.7,2-1.08,3-1.08,2.73-2.14,6.38.19,8.17a5.44,5.44,0,0,0,2.76.92c3.28.37,6.6-.26,9.9-.19,7.21.14,13.92,3.55,20.16,7.16a14,14,0,0,0,4.29,1.88,4.49,4.49,0,0,0,4.29-1.29c1-1.25,1-3,.9-4.64l-1.55-30c-.19-3.67,1-15.1-3.37-16.13-2.78-.66-7.08.7-10,.89-3.51.24-7,.34-10.56.33a18.59,18.59,0,0,1-5.2-.59c-1-.32-4.28-2.13-5.39-1.88-3.39.8-1.94,11.94-2.05,14.56A64,64,0,0,1,185.39,203.13Z",
    transform: "translate(-66.32 -6.04)",
    fill: "url(#linear-gradient-10)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26,223.25a3.45,3.45,0,0,0-2.18.89,3.72,3.72,0,0,0-.59,2.65,160.86,160.86,0,0,0,2.39,22c.16.9.46,2,1.33,2.24,1.27.42,2.24-1.14,2.68-2.4l5.64-16.33a3,3,0,0,0,.23-1.64c-.22-.91-1.22-1.38-1.82-2.11-1.15-1.43-.38-3.88-1.82-5.05C147.84,222.46,144.72,223.06,143.26,223.25Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.93,268.68a3.46,3.46,0,0,0-.8,2.22,3.71,3.71,0,0,0,1.57,2.21,159.58,159.58,0,0,0,17.93,13c.78.48,1.76,1,2.55.52,1.17-.67.66-2.43,0-3.6l-8.35-15.13a2.92,2.92,0,0,0-1-1.27c-.83-.45-1.85,0-2.79-.07-1.84-.1-3.14-2.31-5-2C192.41,264.75,190.77,267.47,189.93,268.68Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26,223.25a3.45,3.45,0,0,0-2.18.89,3.72,3.72,0,0,0-.59,2.65,160.86,160.86,0,0,0,2.39,22c.16.9.46,2,1.33,2.24,1.27.42,2.24-1.14,2.68-2.4l5.64-16.33a3,3,0,0,0,.23-1.64c-.22-.91-1.22-1.38-1.82-2.11-1.15-1.43-.38-3.88-1.82-5.05C147.84,222.46,144.72,223.06,143.26,223.25Z",
    transform: "translate(-66.32 -6.04)",
    fill: "url(#linear-gradient-11)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.93,268.68a3.46,3.46,0,0,0-.8,2.22,3.71,3.71,0,0,0,1.57,2.21,159.58,159.58,0,0,0,17.93,13c.78.48,1.76,1,2.55.52,1.17-.67.66-2.43,0-3.6l-8.35-15.13a2.92,2.92,0,0,0-1-1.27c-.83-.45-1.85,0-2.79-.07-1.84-.1-3.14-2.31-5-2C192.41,264.75,190.77,267.47,189.93,268.68Z",
    transform: "translate(-66.32 -6.04)",
    fill: "url(#linear-gradient-12)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3,
    y: 280.73,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    fill: "#EBCA94"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 71.99,
    y: 321.81,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    fill: "#EBCA94"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 60.69,
    y: 362.89,
    width: 71.61,
    height: 8.29,
    rx: 4.15,
    fill: "#EBCA94"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "68.29 396.5 58.11 396.5 85.81 284 95.99 284 68.29 396.5",
    fill: "#EBCA94"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.82 396.5 114.65 396.5 142.35 284 152.52 284 124.82 396.5",
    fill: "#EBCA94"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M275,7.78V53.35h-2.26V7.4Z",
    transform: "translate(-66.32 -6.04)",
    fill: "#EBCA94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaapplicationsMonochromatic);
export default __webpack_public_path__ + "static/media/Idea applications_Monochromatic.50f3da2aa5484c39907e026690c284cb.svg";
export { ForwardRef as ReactComponent };